module.exports = __webpack_public_path__ + "img/audition-select.8b31cd99.png";